import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles (theme => ({
  root: {
    backgroundColor: "#2d3748",
    color: "#808d9f",
    
  },
  section: {
    marginBottom: 40,
  },
  sectionTitle: {
    position: 'relative',
    padding: '0 3px',
    marginBottom: 20,
    display: 'inline-block',
  },
  sectionTitleText: {
    fontSize: 20,
    fontWeight: 600,
    position: 'relative',
    margin: 0,
  },
  span: {
    position: 'absolute',
    height: 7,
    width: '100%',
    bottom: 0,
    opacity: 0.2,
    left: 0,
    backgroundColor: '#bdbdbd',
  },
  aboutmeText: {
    fontFamily: "'Roboto Slab', serif",
    marginTop: 20,
    textAlign: 'justify'
  },

  /* Skill Section */
  progress: {
    backgroundColor: '#808d9f',
    borderRadius: 20,
    position: 'relative',
    margin: '15px 0',
    height: 15,
    width: "100%",
  },
  progressDone: {
    background: '#2d3748',
    boxShadow: '0 3px 3px -5px #2d3748, 0 2px 5px #808d9f',
    borderRadius: 20,
    color: '#808d9f',
    display: 'flex',
    alignItems: "flex-end",
    justifyContent: 'flex-end',
    height: '100%',
    width: 0,
    opacity: 0,
    transition: '1s ease 0.3s',
  },
  done: {
    fontSize: 12,
    paddingTop: 3,
    marginTop: 10,
    width: 30,
    display: "inline-block",
    height: 18,
    borderRadius: 50,
    textAlign: "center",
    position: "absolute",
    zIndex: 1,
    boxShadow: "0 3px 3px -5px #2d3748, 0 2px 5px #808d9f",
    backgroundColor: "#2d3748"
  },
  skills: {
    marginTop: 20
  }
}));

export default useStyles;
